import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateVerificationStatus } from '../../redux/slices/userSlice';
import { useTranslation } from '../../contexts/LanguageContext';

const VerificationStatusModal = ({ isOpen, onClose, userId, currentStatus, currentRemarks }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [status, setStatus] = useState(currentStatus || 'pending');
  const [remarks, setRemarks] = useState(currentRemarks || '');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await dispatch(updateVerificationStatus({
        userId,
        status,
        remarks
      })).unwrap();

      alert(t("verificationModal.successMsg"));
      onClose();
    } catch (error) {
      alert(t("verificationModal.failedMsg") + error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-800">{t("verificationModal.title")}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("verificationModal.status")}</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border rounded p-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            >
              <option value="pending">{t("verificationModal.statusPending")}</option>
              <option value="approved">{t("verificationModal.statusApproved")}</option>
              <option value="rejected">{t("verificationModal.statusRejected")}</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{t("verificationModal.remarks")}</label>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows={3}
              placeholder={t("verificationModal.remarksPlaceholder")}
              className="w-full border rounded p-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              required
            />
          </div>

          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              {t("verificationModal.cancel")}
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
            >
              {loading ? t("verificationModal.updating") : t("verificationModal.submit")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VerificationStatusModal;
